import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      name: "Naresh Kumar",
      role: "CEO of FarmZen Inc.",
      quote: "Our customer response time dropped from 4 hours to 0 minutes, and we cut support costs by 73%."
    },
    {
      name: "Madhu",
      role: "CEO of ersa technologies",
      logo: "/images/testimonials/ersa-technologies-logo.svg",
      quote: "I was skeptical about AI handling our sales calls, but we've TRIPLED qualified leads while reducing our sales team's prospecting time by 85%."
    },
    {
      name: "Vijesh",
      role: "CEO of CapTalent HR",
      logo: "/images/testimonials/captalent-hr-logo.png",
      quote: "The AI receptionist handles all our incoming calls perfectly. It's like having a world-class receptionist who never sleeps, never has a bad day, and costs 70% less."
    }
  ];

  const llmProviders = [
    { name: "OpenAI GPT-4", logo: "/images/llm-providers/openai-logo.svg" },
    { name: "Anthropic Claude", logo: "/images/llm-providers/anthropic-logo.svg" },
    { name: "Google Gemini", logo: "/images/llm-providers/google-logo.svg" },
    { name: "Groq", logo: "/images/llm-providers/groq-logo.svg" },
    { name: "Meta Llama", logo: "/images/llm-providers/meta-logo.svg" },
    { name: "Mistral AI", logo: "/images/llm-providers/mistral-logo.svg" },
    { name: "Cohere", logo: "/images/llm-providers/cohere-logo.svg" },
    { name: "Hugging Face", logo: "/images/llm-providers/huggingface-logo.svg" },
    { name: "Replicate", logo: "/images/llm-providers/replicate-logo.svg" },
    { name: "Aleph Alpha", logo: "/images/llm-providers/aleph-alpha-logo.svg" },
    { name: "Perplexity", logo: "/images/llm-providers/perplexity-logo.svg" },
    { name: "Together AI", logo: "/images/llm-providers/together-logo.svg" }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Trusted By Innovators</h2>
          <div className="w-20 h-1 bg-primary mx-auto mb-8"></div>
          <p className="max-w-3xl mx-auto text-lg text-gray-700">
            We've helped startups across various industries build robust backend systems with advanced AI capabilities.
          </p>
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto mb-16">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0 mr-4 bg-gray-100 flex items-center justify-center">
                  {testimonial.image ? (
                    <img 
                      src={testimonial.image} 
                      alt={testimonial.name}
                      className="w-full h-full object-cover object-top"
                    />
                  ) : testimonial.logo ? (
                    <img 
                      src={testimonial.logo} 
                      alt={testimonial.name}
                      className="w-full h-full object-contain"
                    />
                  ) : (
                    <div className="w-full h-full bg-primary/10 flex items-center justify-center">
                      <span className="text-primary font-bold text-lg">
                        {testimonial.name.split(' ').map(word => word[0]).join('')}
                      </span>
                    </div>
                  )}
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                  <p className="text-gray-600 text-sm">{testimonial.role}</p>
                </div>
              </div>
              <p className="text-gray-700 italic">"{testimonial.quote}"</p>
              <div className="flex mt-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* LLM Providers Section */}
        <div className="bg-white rounded-xl p-8 shadow-lg">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Powered by Leading LLM Providers</h3>
            <p className="text-gray-600">We integrate with the most advanced language models to deliver cutting-edge AI solutions</p>
          </div>
          
          <div className="flex flex-wrap justify-center items-center gap-4">
            {llmProviders.map((provider, index) => (
              <div key={index} className="flex items-center bg-gray-50 rounded-lg px-4 py-3 hover:bg-primary/5 transition-colors">
                <img 
                  src={provider.logo} 
                  alt={provider.name}
                  className="w-8 h-8 mr-3 object-contain"
                />
                <span className="text-gray-700 font-medium">{provider.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
